export default __webpack_public_path__ + "static/media/arrow.c1afb379.svg";